export default __webpack_public_path__ + "static/media/Manit02.249866cc.png";